import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles(({ colors, palette }: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    height: '64px',
    width: '64px',
    marginBottom: '16px',
  },
  subtitle: {
    color: palette.text.primary,
    fontSize: '16px',
    marginTop: '16px',
  },
  control: {
    marginTop: '33px',
  },
  controlLabel: {
    color: palette.text.primary,
    fontSize: '14px',
    fontFamily: 'Roboto',
  },
  submit: {
    height: '40px',
    borderRadius: '5px',
    fontWeight: 600,
    fontFamily: 'Montserrat',
    color: palette.common.white,
    textTransform: 'none',
    width: '100%',
    '& > span:first-child': {
      paddingTop: '2px',
      paddingBottom: '2px',
    },
  },
  forgot: {
    display: 'block',
    color: colors.section,
    fontSize: '14px',
    marginTop: '10px',
  },
  panelSummary: {
    border: `1px solid ${palette.expansionPanelSummary.borderColor}`,
    background: palette.expansionPanelSummary.background,
    margin: '5px 0px',
  },
  panelDetails: {

  },
  policyContainer: {
    padding: '30px 0 0 0',
  },
  policy: {
    display: 'inline',
  },
  policySwitch: {
    marginRight: 8,
  },
}), { name: 'Register' });

export default useStyles;
